// @todo load dynamicly
// see: /studio/schemas/objects/sectionConfigs.js

import {
  CustomerLogosExtended,
  Subscribe,
  StyleGuide,
  PoweredBy,
  TeamMembers,
  CareersListing,
  CareersBenefits,
  CareersQuoteCluster,
  CareersCarousel,
  CareersHello,
  Newsletters,
  SlackJoin,
  BlogList,
  Hero,
  HeroNext,
  CompanyNews,
  FeaturedMedia,
  Filters,
  PageHeader,
  PageHeaderPlus,
  PageHeaderLogos,
  ResourcesHeader,
  EventsTeaser,
  ChannelsButtons,
  ToggleCta,
  Integrations,
  PricingPlans,
  PricingComparison,
  Profiles,
  CustomerLogos,
  LogoCarousel,
  SlackJoinRedirect,
  DevelopersPanels,
  HubspotWebform,
  ZendeskWebform,
  DemoUX,
  QuickDemoUX,
  PageSectionComponentList,
  AssetRedirect,
  Podcast,
  Divider,
  LinesBg,
  Quotables,
  QuoteWall,
  Videos,
  ResourcesList,
  ResourcesTable,
  CategoryList,
  GetStarted,
  ResourcesSuggestions,
  Tweets,
  IntegrationsList,
  IntegrationsOverview,
  PlaybooksList,
  PlaybooksBlock,
  Badge,
  SearchClient,
  SearchBlog,
  SearchResources,
  SearchHelp,
  SearchResults,
  DocsList,
  Activities,
  QuoteCarousel,
  LandingList,
  SignalsList,
  CustomerStories,
  StoryAvatars,
  SignalSources,
  ComparisonIntegrations,
  PromptList,
  InviteList,
  InviteListPriorityExpress,
  InviteListKoala,
  InviteListFeatured,
  InviteListGrid,
  Chatbot,
  CodeEmbed,
  AccountList,
  PlayFinder,
  PlayFinderEmail,
  EnrichmentCalculator,
  Quiz,
  QuizHero,
  QuizVillains,
  QuizPowers,
  QuizProcess,
  QuizProof,
  QuizShare,
  PromptSelector,
  ObjectionsSelector,
  ScenariosList,
  QuizTest,
  SuggestMachine,
  PlayFinderPreview,
  BrandDownloads,
  TrainingPlaylist,
  GlossaryList,
  RecordingPlaylist
} from "./";

export const getComponentMap = () => {
  const available = new Map();
  available.set("blogList", { component: BlogList });
  available.set("customerLogoWall", { component: CustomerLogosExtended });
  available.set("customerLogoWallShort", { component: CustomerLogos });
  available.set("logoCarousel", { component: LogoCarousel });
  available.set("subscribe", { component: Subscribe, noHeaders: true });
  available.set("styleGuide", { component: StyleGuide });
  available.set("teamMembers", { component: TeamMembers });
  available.set("careers", { component: CareersListing, noHeaders: true });
  available.set("careersBenefits", { component: CareersBenefits });
  available.set("careersQuoteCluster", {
    component: CareersQuoteCluster,
    noHeaders: true,
  });
  available.set("careersCarousel", {
    component: CareersCarousel,
    noHeaders: true,
  });
  available.set("careersHello", { component: CareersHello, noHeaders: true });
  available.set("channelsButtons", { component: ChannelsButtons });
  available.set("toggleCta", { component: ToggleCta, noHeaders: true });
  available.set("newsletters", { component: Newsletters });
  available.set("slack", { component: SlackJoin });
  available.set("slackJoinRedirect", { component: SlackJoinRedirect });
  available.set("hero", { component: Hero, noHeaders: true });
  available.set("heroNext", { component: HeroNext, noHeaders: true });
  available.set("integrationsList", { component: IntegrationsList });
  available.set("integrationsOverview", { component: IntegrationsOverview });
  available.set("pricingIntegrations", { component: ComparisonIntegrations });
  available.set("tweets", { component: Tweets });
  available.set("companyNews", { component: CompanyNews });
  available.set("featuredMedia", { component: FeaturedMedia, noHeaders: true });
  available.set("filters", { component: Filters });
  available.set("header", { component: PageHeader, noHeaders: true });
  available.set("headerPlus", { component: PageHeaderPlus, noHeaders: true });
  available.set("headerLogos", { component: PageHeaderLogos, noHeaders: true });
  available.set("resourcesHeader", { component: ResourcesHeader, noHeaders: true });
  available.set("eventsTeaser", { component: EventsTeaser, noHeaders: true });
  available.set("integrations", { component: Integrations, noHeaders: true });
  available.set("pricingPlans", { component: PricingPlans });
  available.set("pricingComparison", { component: PricingComparison });
  available.set("profiles", { component: Profiles });
  available.set("developersPanels", { component: DevelopersPanels });
  available.set("hubspotWebform", { component: HubspotWebform });
  available.set("zendeskWebform", { component: ZendeskWebform });
  available.set("demoUX", { component: DemoUX });
  available.set("quickDemoUX", { component: QuickDemoUX });
  available.set("pageSectionComponentList", {
    component: PageSectionComponentList,
  });
  available.set("podcast", { component: Podcast });
  available.set("assetRedirect", { component: AssetRedirect });
  available.set("divider", { component: Divider });
  available.set("linesBg", { component: LinesBg });
  available.set("quotables", { component: Quotables });
  available.set("quoteWall", { component: QuoteWall });
  available.set("videos", { component: Videos });
  available.set("resourcesList", { component: ResourcesList });
  available.set("categoryList", { component: CategoryList });
  available.set("resourcesTable", { component: ResourcesTable });
  available.set("playbooksList", { component: PlaybooksList });
  available.set("resourcesSuggestions", { component: ResourcesSuggestions });
  available.set("getStarted", { component: GetStarted, noHeaders: true });
  available.set("playbooksBlock", { component: PlaybooksBlock });
  available.set("badge", { component: Badge, noHeaders: true });
  available.set("searchResources", { component: SearchResources });
  available.set("searchHelp", { component: SearchHelp });
  available.set("searchBlog", { component: SearchBlog });
  available.set("docsList", { component: DocsList });
  available.set("activities", { component: Activities });
  available.set("quoteCarousel", { component: QuoteCarousel });
  available.set("landingList", { component: LandingList });
  available.set("signalsList", { component: SignalsList });
  available.set("signalSources", { component: SignalSources });
  available.set("customerStories", { component: CustomerStories });
  available.set("storyAvatars", { component: StoryAvatars });
  available.set("promptList", { component: PromptList });
  available.set("inviteList", { component: InviteList });
  available.set("inviteListPriorityExpress", { component: InviteListPriorityExpress });
  available.set("inviteListKoala", { component: InviteListKoala });
  available.set("inviteListFeatured", { component: InviteListFeatured });
  available.set("inviteListGrid", { component: InviteListGrid, noHeaders: true });
  available.set("chatbot", { component: Chatbot });
  available.set("codeEmbed", { component: CodeEmbed, noHeaders: true });
  available.set("accountList", { component: AccountList, noHeaders: true });
  available.set("playFinder", { component: PlayFinder, noHeaders: true });
  available.set("playFinderEmail", { component: PlayFinderEmail, noHeaders: true });
  available.set("enrichmentCalculator", { component: EnrichmentCalculator, noHeaders: true });
  available.set("quiz", { component: Quiz, noHeaders: true });
  available.set("quizHero", { component: QuizHero, noHeaders: true });
  available.set("quizVillains", { component: QuizVillains, noHeaders: true });
  available.set("quizPowers", { component: QuizPowers, noHeaders: true });
  available.set("quizProcess", { component: QuizProcess, noHeaders: true });
  available.set("quizShare", { component: QuizShare, noHeaders: true });
  available.set("quizTest", { component: QuizTest, noHeaders: true });
  available.set("promptSelector", { component: PromptSelector });
  available.set("objectionsSelector", { component: ObjectionsSelector });
  available.set("scenariosList", { component: ScenariosList });
  available.set("suggestMachine", { component: SuggestMachine });
  available.set("playFinderPreview", { component: PlayFinderPreview, noHeaders: true });
  available.set("brandDownloads", { component: BrandDownloads });
  available.set("trainingPlaylist", { component: TrainingPlaylist });
  available.set("glossaryList", { component: GlossaryList });
  available.set("recordingPlaylist", { component: RecordingPlaylist });
  return available;
};

export { SectionWrapper } from "./wrapper";
export { BlogList } from "./snowflake/blog-list";
export { CustomerLogos, CustomerLogosExtended } from "./logos";
export { LogoCarousel } from "./logo-carousel";
export { Tweets } from "./snowflake/tweets";
export { Subscribe } from "./subscribe";
export { PageSectionSimple } from "./simple-content";
export { StyleGuide } from "./style-guide";
export { PageSectionColumns } from "./column-content";
export { PoweredBy } from "./snowflake/powered-by";
export { TeamMembers } from "./snowflake/team-members";
export { CareersListing } from "./snowflake/careers";
export {
  CareersBenefits,
  CareersQuoteCluster,
  CareersCarousel,
  CareersHello,
} from "./snowflake/careers-blocks";
export { Newsletters } from "./snowflake/newsletters";
export { SlackJoin, SlackJoinRedirect } from "./snowflake/slack-join";
export { Hero, Activities, HeroNext } from "./snowflake/hero";
export { CompanyNews } from "./snowflake/company-news";
export { FeaturedMedia } from "./featured-media";
export { Filters } from "./filters";
export { PageHeader, PageHeaderPlus, PageHeaderLogos } from "./page-header";
export { ResourcesHeader } from "./snowflake/resources-header";
export { EventsTeaser } from "./snowflake/events-teaser";
export { ChannelsButtons } from "./snowflake/channels-buttons";
export { ToggleCta } from "./toggle-cta";
export { Integrations } from "./snowflake/integrations";
export { PricingPlans } from "./snowflake/pricing-plans";
export { PricingComparison } from "./snowflake/pricing-comparison";
export { PricingPlansSection } from "./snowflake/pricing-plans-section";
export { PricingComparisonSection } from "./snowflake/pricing-comparison-section";
export { Profiles } from "./snowflake/profiles";
export { DevelopersPanels } from "./snowflake/developers";
export { HubspotWebform } from "./hubspot-webform";
export { ZendeskWebform } from "./zendesk-webform";
export { DemoUX } from "./demo-ux";
export { QuickDemoUX } from "./quick-demo-ux";
export { PageSectionComponentList } from "./component-columns";
export { AssetRedirect } from "./snowflake/download-asset";
export { Podcast } from "./snowflake/podcast";
export { Divider, LinesBg } from "./divider";
export { Quotables } from "./quotables";
export { QuoteWall } from "./quote-wall";
export { Videos } from "./videos";
export { ResourcesList, ResourcesTable } from "./resources-list";
export { CategoryList } from "./categories";
export { ResourcesSuggestions } from "./resources-suggestions";
export { PlaybooksList } from "./playbooks-list";
export { GetStarted } from "./snowflake/get-started-banner";
export { IntegrationsList } from "./snowflake/integrations-list";
export { PlaybooksBlock } from "./playbooks-block";
export { Badge } from "./badge";
export { IntegrationsOverview } from "./snowflake/integrations-overview";
export { SearchBlog, SearchResources, SearchHelp } from "./snowflake/search";
export { DocsList } from "./docs-list";
export { QuoteCarousel } from "./quote-carousel";
export { LandingList } from "./landing-list";
export { SignalsList } from "./signals-list";
export { CustomerStories } from "./snowflake/customer-stories";
export { StoryAvatars } from "./snowflake/story-avatars";
export { SignalSources } from "./snowflake/signal-sources";
export { ComparisonIntegrations } from "./snowflake/comparison-integrations";
export { PromptList } from "./prompts-list";
export { InviteList, InviteListPriorityExpress, InviteListKoala, InviteListFeatured, InviteListGrid } from "./invite-list";
export { Chatbot } from "./chatbot";
export { CodeEmbed } from "./code-embed";
export { AccountList } from "./account-list";
export { PlayFinder, PlayFinderEmail, PlayFinderPreview } from "./snowflake/play-finder";
export { EnrichmentCalculator } from "./enrichment-calculator";
export { Quiz } from "./quiz/quiz.js";
export { QuizHero } from "./quiz/quiz-hero";
export { QuizPowers } from "./quiz/quiz-powers";
export { QuizVillains } from "./quiz/quiz-villains";
export { QuizProcess, QuizTest } from "./quiz/quiz-blocks";
export { QuizShare } from "./quiz/quiz-share";
export { PromptSelector } from "./prompt-selector";
export { ObjectionsSelector } from "./objections-selector";
export { ScenariosList } from "./scenarios-list";
export { SuggestMachine } from "./suggest-machine";
export { BrandDownloads } from "./brand-downloads";
export { TrainingPlaylist } from "./training-playlist";
export { GlossaryList } from "./glossary-list";
export { RecordingPlaylist } from "./recording-playlist";
